<app-application-steps [showTechnicalFormFirst]="true" [currentStep]="step" [isDetailsView]="isDetailsView"></app-application-steps>

<div class="component-container" id="print-form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'installation-data.reg-ep' | translate }}
      <span *ngIf="isDetailsView">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'app.navigation.regulatory-data' | translate }}
    </div>
  </div>

  <div *ngIf="isLoading" class="loader-container">
    <div class="loader-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>

  <div *ngIf="!isLoading" class="technical-data-form-container">
    <form #regulatoryForm="ngForm" class="form-section form-font-size">
      <app-waiver-feed-in-compensation
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-waiver-feed-in-compensation>

      <app-models-feed-in-compensation
        *ngIf="!regulatoryData?.is_waiver_compensation"
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-models-feed-in-compensation>

      <app-bank-account-details
        *ngIf="!regulatoryData?.is_waiver_compensation"
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-bank-account-details>

      <app-tax-payment-declaration
        *ngIf="!regulatoryData?.is_waiver_compensation"
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-tax-payment-declaration>

      <app-energy-producers-registration
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        (eegEnergyProducersFormChanged)="eegEnergyProducersFormChanged($event)"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-energy-producers-registration>

      <app-energy-producers-authorization
        [isDetailsView]="isDetailsView"
        [regulatoryData]="regulatoryData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [regulatoryForm]="regulatoryForm"
        [applicationId]="applicationId"
        [energySource]="techDataEnergySource"
        (lockUnlockButtonClick)="isFeedbackChanged = true"
        (changeCommentText)="isFeedbackChanged = true"></app-energy-producers-authorization>

      <app-order-history
        *ngIf="isDetailsView"
        [applicationId]="applicationId"
        [pagination]="true"
        (formChange)="historyLogForm = $event"></app-order-history>

      <div class="ui-g-12 submit-button-section">
        <button
          *ngIf="isDetailsView"
          type="button"
          class="ui-button mr-3"
          (click)="previousPage()"
          label="{{ 'grid-comp.back' | translate | uppercase }}"
          pButton></button>
        <button
          data-testId="btn-save"
          *ngIf="isDetailsView"
          type="button"
          class="ui-button-save mr-3"
          (click)="saveFormData(false)"
          [disabled]="
            !isRegulatoryFormValid || !energyProducersFormValid || !(regulatoryForm.dirty || energyProducersFormDirty || isFeedbackChanged)
          "
          label="{{ 'grid-comp.save' | translate | uppercase }}"
          pButton></button>
        <button
          data-testId="btn-proceed"
          type="button"
          class="ui-button-proceed"
          (click)="saveFormData(true)"
          [disabled]="!isRegulatoryFormValid || !energyProducersFormValid"
          label="{{ 'grid-comp.proceed' | translate | uppercase }}"
          pButton></button>
      </div>
    </form>
  </div>
</div>
